import {Component, EventEmitter, Inject, Output} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

interface ConfirmationDialogData {
  cancelButtonText?: string;
  confirmationPromptText: string;
  confirmButtonText: string;
  headerText?: string;
  showCancelButton: boolean;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: false
})
export class ConfirmationDialogComponent {
  @Output() cancel = new EventEmitter();
  @Output() confirm = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) {}
}
